import { memo, useCallback } from "react";
import PropTypes from "prop-types";
import "./SmartDPReInsurance.scss";
import ProgressiveImg from "app/pages/.shared/ProgressiveImg";
import Paragraphs from "app/pages/.shared/Paragraphs";
import { useAnalytics } from "app/utils/analytics/useAnalytics";
import { useLocation } from "react-router-dom";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import classNames from "classnames";
import Button, { BUTTON_VARIANTS } from "app/pages/.shared/form/Button";

const IMG_SIZES = {
	small: { width: 600 },
	medium: { width: 600 },
	large: { width: 350, height: 196 },
	xlarge: { width: 350, height: 196 },
};

const SmartDPReInsurance = ({
	resolution,
	title = "",
	introduction = [],
	image,
	thumbnail,
	text = [],
	openInNewWindow,
	buttonLabel,
	photoPosition,
	url,
}) => {
	const { track } = useAnalytics();
	const location = useLocation();

	const target = openInNewWindow ? "_blank" : "_self";

	const handleCTAClick = useCallback(() => {
		track("reinsurance_block_cta_click", {
			ctaLabel: buttonLabel,
			title: title,
			actualUrl: location.pathname,
			redirectUrl: url,
		});
	}, [buttonLabel, title, url, location.pathname]);
	const reinsuranceClassNames = classNames("sdp-reinsurance", {
		"sdp-reinsurance--reverse": photoPosition === "right",
	});
	return (
		<div className={reinsuranceClassNames}>
			<div className="sdp-reinsurance__container">
				{title && (
					<>
						<Typography
							variant={TYPOGRAPHY_VARIANTS.XL3}
							variantMD={TYPOGRAPHY_VARIANTS.XL4}
							isBold
							className="sdp-reinsurance__title"
							component="h2"
						>
							<Paragraphs paragraphs={title} enableHTMLFormatting />
						</Typography>
						{introduction && introduction?.length > 0 && (
							<div className="sdp-reinsurance__introduction">
								<Paragraphs paragraphs={introduction} enableHTMLFormatting />
							</div>
						)}
					</>
				)}
				<div className="sdp-reinsurance__texte">
					<Paragraphs paragraphs={text} enableHTMLFormatting />
				</div>
				{url && buttonLabel && (
					<Button
						variant={BUTTON_VARIANTS.STROKE}
						to={{ pathname: url }}
						onClick={handleCTAClick}
						label={buttonLabel}
						className="sdp-reinsurance__cta"
						target={target}
						data-testid="reinsurance-cta"
					/>
				)}
			</div>
			{image && (
				<div className="sdp-reinsurance__image">
					<ProgressiveImg
						sizes={IMG_SIZES}
						resolution={resolution}
						src={image}
						thumbnail={thumbnail}
					/>
				</div>
			)}
		</div>
	);
};

SmartDPReInsurance.propTypes = {
	resolution: PropTypes.string,
	title: PropTypes.string,
	introduction: PropTypes.array,
	image: PropTypes.string,
	thumbnail: PropTypes.string,
	photoPosition: PropTypes.string,
	text: PropTypes.array,
	openInNewWindow: PropTypes.bool,
	buttonLabel: PropTypes.string,
	url: PropTypes.string,
};

export default memo(SmartDPReInsurance);
